import React, { useState } from 'react';
import { X, User, Mail, Phone, MessageSquare, CheckCircle } from 'lucide-react';
import axiosInstance from "../../api/axiosInstance";
import Button from '../shared/Button';

const INITIAL_FORM_STATE = {
  name: '',
  email: '',
  phone: '',
  comment: ''
};

const collectAttributionPayload = (landingSport = '') => {
  if (typeof window === 'undefined') {
    return {};
  }

  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source') || '';
  const utmMedium = params.get('utm_medium') || '';
  const utmCampaign = params.get('utm_campaign') || '';
  const utmContent = params.get('utm_content') || '';
  const utmTerm = params.get('utm_term') || '';

  let trafficSource = utmSource;
  if (!trafficSource) {
    if (params.get('fbclid')) trafficSource = 'facebook_ads';
    else if (params.get('gclid')) trafficSource = 'google_ads';
    else trafficSource = 'direct';
  }

  return {
    landing_sport: landingSport || params.get('sport') || '',
    traffic_source: trafficSource,
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
    utm_content: utmContent,
    utm_term: utmTerm,
    referrer_url: document.referrer || '',
    landing_url: window.location.href || '',
  };
};

const ProgramRegistrationModal = (props) => {
  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  if (!props.program || !props.onClose) {
    return null;
  }

  const { program, onClose, landingSport } = props;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const submitData = {
      program: program.id,
      ...formData,
      ...collectAttributionPayload(landingSport),
    };

    try {
      console.log('Sending registration data:', submitData);
      const response = await axiosInstance.post('/programs-registrations/', submitData);
      console.log('Registration response:', response.data);

      setSuccess(true);
      setTimeout(() => onClose(), 2000);

    } catch (err) {
      console.error('Registration error:', err);
      setError('Произошла ошибка. Пожалуйста, попробуйте снова.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl max-w-md w-full p-8 text-center">
          <div className="mb-4 flex justify-center">
            <div className="w-16 h-16 bg-[#28c4f4]/10 rounded-full flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-[#28c4f4]" />
            </div>
          </div>
          <h3 className="text-2xl font-bold mb-2">Заявка отправлена!</h3>
          <p className="text-gray-600">Спасибо за вашу заявку. Мы свяжемся с вами в ближайшее время.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-xl w-full relative overflow-hidden">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <X className="w-6 h-6 text-gray-400" />
        </button>

        <div className="bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] p-6 text-white">
          <h3 className="text-2xl font-bold mb-2">Получить Консультацию  </h3>
          <p className="text-white/90">{program.title}</p>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="space-y-4">
            <div className="relative">
              <User className="absolute top-3 left-3 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Ваше имя"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4897d2] focus:border-transparent"
              />
            </div>

            <div className="relative">
              <Mail className="absolute top-3 left-3 w-5 h-5 text-gray-400" />
              <input
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4897d2] focus:border-transparent"
              />
            </div>

            <div className="relative">
              <Phone className="absolute top-3 left-3 w-5 h-5 text-gray-400" />
              <input
                type="tel"
                placeholder="Телефон"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                required
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4897d2] focus:border-transparent"
              />
            </div>
          </div>


          <div className="relative">
            <MessageSquare className="absolute top-3 left-3 w-5 h-5 text-gray-400" />
            <textarea
              placeholder="Комментарий или вопрос"
              value={formData.comment}
              onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
              rows="3"
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4897d2] focus:border-transparent"
            ></textarea>
          </div>

          {error && (
            <div className="text-red-500 text-sm">{error}</div>
          )}

          <Button
            type="submit"
            disabled={loading}
            className="w-full"
          >
            {loading ? 'Отправка...' : 'Отправить заявку'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ProgramRegistrationModal;
